import DonorGridData from "./Models/DonorGridData"
import DonorGridOptions from "./Models/DonorGridOptions"
import ImportErrorType from "./Models/NoMatchingErrorType"
import OrphanedDonorAcceptOptions from "./Models/OrphanedDonorAcceptOptions"
import OrphanedRow from "./Models/OrphanedRow"
import PendingDrugTest from "./Models/PendingDrugTest"
import PendingDrugTestGridData from "./Models/PendingDrugTestGridData"
import PendingDrugTestOptions from "./Models/PendingDrugTestOptions"
import { ObservableFromFetch } from "../ObservableFromFetch"

export function GetPendingDrugTestsObservable(options: PendingDrugTestOptions) {
  const requestBody: string = JSON.stringify(options)
  return ObservableFromFetch<PendingDrugTestGridData>("WorkforceResultExceptions/PendingDrugTests", requestBody)
}

export function GetDonorsObservable(parameters: DonorGridOptions) {
  const requestBody: string = JSON.stringify(parameters)
  return ObservableFromFetch<DonorGridData>("WorkforceResultExceptions/SearchDonors", requestBody)
}

export function NoMatchingRandomAcceptObservable(importTestDetail: OrphanedRow, pendingTestDetail: PendingDrugTest) {
  const requestBody: string = JSON.stringify({
    ImportTestDetailID: importTestDetail.TestDetailID,
    PendingTestDetailID: pendingTestDetail.TestDetailID,
    KeepTestReason: importTestDetail.Reason === "Random" && pendingTestDetail.Reason !== "RAN",
    ImportErrorType: ImportErrorType.NoMatchingRandom,
    TestDetailImportID: importTestDetail.TestDetailImportID,
    TestImportExceptionID: importTestDetail.TestImportExceptionID,
  })
  return ObservableFromFetch<string>("WorkforceResultExceptions/NoMatchingAccept", requestBody)
}

export function NoMatchingTestAcceptObservable(importTestDetail: OrphanedRow, pendingTestDetail: PendingDrugTest) {
  const requestBody: string = JSON.stringify({
    ImportTestDetailID: importTestDetail.TestDetailID,
    PendingTestDetailID: pendingTestDetail.TestDetailID,
    KeepTestReason: true,
    ImportErrorType: ImportErrorType.NoMatchingTest,
    TestDetailImportID: importTestDetail.TestDetailImportID,
    TestImportExceptionID: importTestDetail.TestImportExceptionID,
  })
  return ObservableFromFetch<string>("WorkforceResultExceptions/NoMatchingAccept", requestBody)
}

export function NoAccountAcceptObservable(
  labAccount: string,
  accountID: number,
  testDetailImportID: number,
  testImportExceptionID: number
) {
  const requestBody: string = JSON.stringify({
    LabAccount: labAccount,
    AccountID: accountID,
    TestDetailImportID: testDetailImportID,
    TestImportExceptionID: testImportExceptionID,
  })
  return ObservableFromFetch<string>("WorkforceResultExceptions/NoAccountAccept", requestBody)
}

export function DonorNotFoundAcceptObservable(options: OrphanedDonorAcceptOptions) {
  const requestBody: string = JSON.stringify(options)
  return ObservableFromFetch<string>("WorkforceResultExceptions/DonorNotFoundAccept", requestBody)
}

export function NoMatchingCreateNewObservable(importTestDetail: OrphanedRow) {
  const requestBody: string = JSON.stringify({
    ImportTestDetailID: importTestDetail.TestDetailID,
    TestDetailImportID: importTestDetail.TestDetailImportID,
    TestImportExceptionID: importTestDetail.TestImportExceptionID,
  })
  return ObservableFromFetch<string>("WorkforceResultExceptions/NoMatchingCreateNew", requestBody)
}
